import { type BentoSatellite, BentoSection } from './bento-section'
import { WideScroll } from './mockups/base'
import {
  BriefingMockup,
  ClienteContextoMockup,
  FunilMockup,
  PropostaPublicaMockup,
} from './mockups/modules'

/*
 * O funil, contado pelas telas reais: o quadro de leads como âncora e as
 * três superfícies que o alimentam — briefing por link, proposta pública e
 * a ficha do cliente que junta tudo.
 */

const SATELLITES: BentoSatellite[] = [
  {
    body: 'Mande um link, o cliente responde no celular com fotos de referência, e as respostas viram um lead com contexto no funil.',
    title: 'Briefing por link',
    visual: <BriefingMockup />,
  },
  {
    body: 'A proposta sai no papel timbrado do escritório. O cliente abre pelo link, aceita ou recusa, e o aceite eletrônico fica registrado.',
    title: 'Proposta pública',
    visual: <PropostaPublicaMockup />,
  },
  {
    body: 'Cada contato carrega o que já aconteceu com ele: projetos em andamento, propostas, briefings respondidos e a última visita.',
    title: 'O cliente com histórico',
    visual: <ClienteContextoMockup />,
  },
]

export const FunnelBento = () => (
  <BentoSection
    accent="#7a6cb6"
    anchor={
      <WideScroll>
        <FunilMockup />
      </WideScroll>
    }
    background="bg-gradient-to-b from-white to-[#f6f4fc]"
    cardBg="bg-white"
    cardBorder="border-[#e7e3f4]"
    heading="Do primeiro lead ao contrato assinado"
    hrefLabel="Ver tudo do funil"
    hrefTo="/recursos/funil"
    intro="CRM, briefings de intake e propostas com link público. Tudo conectado pelo mesmo contato, sem planilha paralela."
    layout="showcase"
    satellites={SATELLITES}
  />
)
